import { Api } from './api';

import type { 
  AddProviderProduct, 
  ProviderProduct, 
  UpdatePercentProviderProduct, 
  UpdateProviderProduct 
} from '../types/providerProduct.type';

export class ProviderProductApi extends Api {

  static async add(providerProduct: AddProviderProduct) {
    return this.post<ProviderProduct>('/provider-product', providerProduct);
  }

  static async update(id: number, providerProduct: UpdateProviderProduct) {
    return this.patch<ProviderProduct>(`/provider-product/${id}`, providerProduct);
  }

  static async updatePercent(providerProducts: UpdatePercentProviderProduct[]) {
    return this.patch<ProviderProduct>('/provider-product/percent', { products: providerProducts });
  }

  static async delete(id: number) {
    await this.remove(`/provider-product/${id}`);
  }
}
